import { jsx as _jsx } from "react/jsx-runtime";
import GatewayAssignmentCard from '../Card/GatewayAssignmentCard';
function GatewayAssignmentView(props) {
    const { userCustomers } = props;
    return _jsx("div", { children: userCustomers && _jsx(GatewayAssignmentCard, { ...props }) });
}
/** @deprecated - No longer used */
export default GatewayAssignmentView;
